try{self['workbox:streams:4.3.1']&&_()}catch(e){}// eslint-disable-line